/* eslint-disable no-shadow */
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./courseStyles.scss";

export default function Component({ title, onClick, component, preview, index }) {
  const [quizVacio, setQuizVacio] = useState(false);

  useEffect(() => {
    if (component.type === "Quiz") {
      const quiz = component.labQuiz;
      const questions = quiz.labQuizQuestion;
      if (questions.length === 0) {
        setQuizVacio(true);
      }
    }
  }, [component]);

  return (
    <div className="my-1" style={{ display: "flex", width: "100%" }}>
      <div className="handler" style={preview ? { height: "20px", width: "5%" } : { height: "20px" }}>
        {preview ? <div className="card-text m-1">{index + 1}</div> : <FontAwesomeIcon icon="fa-solid fa-grip-vertical" />}
      </div>
      <div id="component" style={preview ? { width: "95%", fontFamily: "DM Sans", border: quizVacio ? "1px solid red" : "none" } : null}>
        {preview ? (
          <>
            <p className="mb-0" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", margin: "2px" }}>
              {title}
            </p>
            {quizVacio ? <p style={{ color: "red" }}>No hay preguntas</p> : null}
          </>
        ) : (
          <>
            <button type="button" id="component-button" onClick={() => onClick(component)}>
              <p className="card-text" style={{ textAlign: "left", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", margin: "2px" }}>
                {title}
              </p>
            </button>
          </>
        )}
      </div>
    </div>
  );
}
